module.exports = __webpack_public_path__ + "img/fire100.3d7df097.gif";